import { useEffect } from 'react';

import { FullScreenModal } from '@moniebook-web/components/molecules/full-screen-modal';
import { MoniebookLoader } from '@moniebook-web/components/molecules/moniebook-loader';
import { useScreenInfo } from '@moniebook-web/components/shared/hooks';
import { useMobileSettingsMenuStore } from '@moniebook-web/store';
import { Outlet, useLocation, useNavigation } from 'react-router';

import { PagesWithoutSettingsSidebar } from './constants';
import { SettingsSidebar } from './sidebar/sidebar';

export function SettingsLayout() {
    const { show, setShow } = useMobileSettingsMenuStore();
    const location = useLocation();
    const screenSize = useScreenInfo().screenSize;
    const isDesktop = screenSize === 'xl';
    const pathname = location.pathname;
    const isSettingsPage = pathname.startsWith('/dashboard/settings');
    const isSidebarHidden = PagesWithoutSettingsSidebar[pathname];
    const { state } = useNavigation();

    // biome-ignore lint/correctness/useExhaustiveDependencies: pathname/isDesktop are deliberate triggers to close the mobile menu on navigation or breakpoint change, not read in the effect body
    useEffect(() => {
        setShow(false);
    }, [setShow, pathname, isDesktop]);

    return (
        <>
            {isSettingsPage && (
                <div className='flex grow overflow-auto'>
                    {!isSidebarHidden && (
                        <div className='desktop:block hidden h-full'>
                            <SettingsSidebar />
                        </div>
                    )}
                    <div className='relative z-1 flex h-full flex-1 flex-col overflow-y-auto overflow-x-hidden bg-white'>
                        {state === 'loading' ? (
                            <MoniebookLoader fullHeight />
                        ) : (
                            <Outlet />
                        )}
                    </div>
                </div>
            )}
            <FullScreenModal isOpen={show} onClose={() => setShow(false)}>
                <div className='mobileSettingsSidebar'>
                    <SettingsSidebar />
                </div>
            </FullScreenModal>
        </>
    );
}
